/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { Contract, ContractFactory, ethers } from 'ethers';
import React, { createContext, useContext, useEffect, useState } from 'react';

//import { coingeckoUrl, pinListUrl } from '../config/constants';
//import { pinListUrl } from '../config/constants';
//import { pinataAPIkey, pinataAPIsecret } from '../config/pinata.config';
import atoSC from '../contracts/Ato.json';
import NFTMakerSC from '../contracts/Registry.json';
import NFTMakerAddress from '../contracts/RegistryAddress.json';
import NFTMakerAddressRinkeby from '../contracts/RegistryAddressRinkeby.json';
import NFTMakerAddressMumbai from '../contracts/RegistryAddressMumbai.json';
import NFTMakerAddresPolygon from '../contracts/RegistryAddressPolygon.json';
import NFTMakerAddresEthereum from '../contracts/RegistryAddressEthereum.json';
import NFTMakerAddresOptimism from '../contracts/RegistryAddressOptimism.json';
import { ConnectWallet } from '../pages/ConnectWallet';
//import { NoWalletDetected } from '../pages/NoWalletDetected';
import { AuthContext, HARDHAT_NETWORK_NAME } from '../providers/AuthProvider';

export const NftContext = createContext();

const Exception = (type, message, e) => {
  return { type: type, message: message, error: e };
};

const generateUrl = (hash) => {
  console.log("hash: " + hash);
  const hashUrl = `https://ipfs.io/ipfs/${hash}`; // https://ato-nft.mypinata.cloud/ipfs/<hash>
  console.log("hashUrl: " + hashUrl);
  return hashUrl;
}

const NftProvider = ({ children }) => {
  const authCtxt = useContext(AuthContext);
  const [isWhitelisted, setIsWhitelisted] = useState(true);
  const [nfts, setNfts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [resultToast, setResultToast] = useState({ display: false, content: '' });
  const [pdf, setPdf] = useState(null);
  //const [research, setResearch] = useState('');
  const [waitForTx, setWaitForTx] = useState({
    hash: '',
    message: '',
    status: '',
  });

  const processing = {
    hash: '',
    message: 'Processing... It can take up to 3 minutes.',
    status: 'in progress',
  };

  // get and update Artworks
  useEffect(() => {
    setLoading(true);
    console.log('getting artworks');
    getArtworksFromMarket();
    getAuthorIsVerified();
  }, [reload]);

  if (!window.ethereum) {
    //return <NoWalletDetected />;
    return (
      <ConnectWallet
        connectWallet={() => authCtxt._connectWallet()}
        autoConnectWallet={() => authCtxt._autoConnectWallet()}
        networkName={HARDHAT_NETWORK_NAME}
        networkError={authCtxt.networkError}
        dismiss={() => authCtxt._dismissNetworkError()}
      />
    );
  }

  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner(0);

  // default : localhost
  let marketAddress = NFTMakerAddress.Registry;

  //network Rinkeby
  if (window.ethereum.networkVersion === '4') {
    marketAddress = NFTMakerAddressRinkeby.Registry;
  }
  //network Mumbai
  if (window.ethereum.networkVersion === '80001') {
    marketAddress = NFTMakerAddressMumbai.Registry;
  }
  //network Polygon
  if (window.ethereum.networkVersion === '137') {
    marketAddress = NFTMakerAddresPolygon.Registry;
  }
  //network Optimism
  if (window.ethereum.networkVersion === '69') {
    marketAddress = NFTMakerAddresOptimism.Registry;
  }

  //ethereum
  if (window.ethereum.networkVersion === '1') {
    marketAddress = NFTMakerAddresEthereum.Registry;
  }

  const market = new Contract(marketAddress, NFTMakerSC.abi, signer);

  const isAuthorOfArtwork = (listArtworksByAuthor, address) => {
    for (let i = 0; i < listArtworksByAuthor.length; i++) {
      if (listArtworksByAuthor[i][0] === address) return true;
    }
    return false;
  }

  /**
   * Get Ato contracts on the market and format them
   */
  const getArtworksFromMarket = async () => {
    setNfts([]);
    //console.log("before artworksCountInMarket");
    let addressSigner = await signer.getAddress();
    const getCountArtworks = await market.getCountArtworks();
    console.log("getCountArtworks: " + getCountArtworks);
    //const getCountArtworksByAuthor = await market.getCountArtworksByAuthor(addressSigner);
    //console.log("getCountArtworksByAuthor: " + getCountArtworksByAuthor);
    console.log("addressSigner: ", addressSigner);

    //if (!getCountArtworksByAuthor) {
    //  setLoading(false);
    //  return;
    //}

    setWaitForTx({ hash: '', message: 'Loading NFT.', status: 'in progress' });

    const artworksInMarket = await market.getArtworks();
    //const artworksInMarket = await market.getArtworksByAuthor(signer.getAddress());
    console.log("artworksInMarket.length: " + artworksInMarket.length);

    const listArtworksByAuthor = await market.getArtworksByAuthor(addressSigner);
    console.log("listArtworksByAuthor.length: " + listArtworksByAuthor.length);

    if (!artworksInMarket.length) {
      setLoading(false);
      return;
    }

    // get all contracts from market
    artworksInMarket.map(async (artwork) => {
      let address = artwork[0];
      let price = artwork[1] / 10 ** 18;
      let max = artwork[2];
      let verified = artwork[3];
      let current = artwork[4];

      const ato = new Contract(address, atoSC.abi, signer);
      let addArtwork = false;
      let isAuthor = false;
      let addressBalance = 0;
      if (isAuthorOfArtwork(listArtworksByAuthor, address)) {
        addArtwork = true;
        isAuthor = true;
      } else {
        addressBalance = await ato.balanceOf(addressSigner);
        if (addressBalance > 0) addArtwork = true;
      }

      if (addArtwork) {
        current = await ato.getTokenIdCounter();

        // get metadatas and pinatas datas from ato contract and IPS
        const atoMetadatasUrl = await ato.metadata();
        //console.log("atoMetadatasUrl: ", atoMetadatasUrl);
        const metadatas = await axios.get(atoMetadatasUrl);
        //console.log("metadatas: ", metadatas);

        //const pinataArt = await getArtwork(address);
        console.log("loading artwork: " + address);
      //if (pinataArt) {
        // Format Nft
        const Nft = {
          name: metadatas.data.name,
          author: metadatas.data.author,
          authorAddress: addressSigner,//authorAddress: pinataArt.metadata.keyvalues.authorAddress,
          description: metadatas.data.description,
          thumbnailUrl: metadatas.data.thumbnailUrl, //pinataArt.metadata.keyvalues.thumbnailUrl,
          id: metadatas.data.ipfs_pin_hash, //pinataArt.ipfs_pin_hash,
          artUrl: metadatas.data.ipfs_pin_hash !== undefined ? generateUrl(metadatas.data.ipfs_pin_hash) : metadatas.data.image,
          picType: metadatas.data.media_format,
          pdfUrl: metadatas.data.IP_rights !== undefined ? metadatas.data.IP_rights : metadatas.data.IP_license,
          address: artwork[0],
          price: price,
          max: max.toNumber(),
          verified: verified,
          left: isAuthor ? max.toNumber() - current.toNumber() : 0,
          metadatasUrl: atoMetadatasUrl,
        };
        setNfts((nfts) => [...nfts, Nft]);
      }
      //setWaitForTx({ hash: '', message: '', status: '' });
      //setLoading(false);
    });
    setWaitForTx({ hash: '', message: '', status: '' });
    setLoading(false);
  };

  /**
    * Get the state of whitelisting
    */
  const getAuthorIsVerified = async () => {
    try {
      //const addressSigner = await signer.getAddress();
      //const state = await market.isWhitelisted(addressSigner);
      setIsWhitelisted(true);
    } catch (error) {
      setIsWhitelisted(false);
    }
  }
  window.ethereum.on('accountsChanged', () => { getAuthorIsVerified() });

  /**
   *  Get pinned Artwork from IPFS by contract address
   */
  /*   const getArtwork = async (address) => {
    //console.log(`getArtwork url: ${pinListUrl}&metadata[keyvalues]={"contractAddress":{"value":"${address}","op":"like"}}`);
    try {
      const {
        data: { rows },
      } = await axios.get(`${pinListUrl}&metadata[keyvalues]={"contractAddress":{"value":"${address}","op":"like"}}`, {
        headers: {
          pinata_api_key: pinataAPIkey,
          pinata_secret_api_key: pinataAPIsecret,
        },
      });
      return rows[0];
    } catch (error) {
      console.error('Error getting pin list', error);
    }
  }; */

  /**
   * Deploy smart contract, handleprocessing
   * @param {String} artworkHash
   */
  const deployContract = async (artworkName, symbol, metadatasUrl, supplyNumber, mintNumber, royalties, authorWalletAddress) => {
    setWaitForTx({ hash: '', message: 'Please approve contract deployment ! (Metamask action is required)', status: 'in progress' });

    try {
      const factory = new ContractFactory(atoSC.abi, atoSC.bytecode, signer);
      //console.log("artworkName: " + artworkName);
      //console.log("symbol: " + symbol);
      //console.log("metadatasUrl: " + metadatasUrl);
      //console.log("supplyNumber: " + supplyNumber);
      //console.log("mintNumber: " + mintNumber);
      //console.log("marketAddress: " + marketAddress);
      // TODO : ajout calc gaslimit = nbExp * 200K + 5M (attention au gas max)
      const contract = await factory.deploy(artworkName, symbol, metadatasUrl, supplyNumber, mintNumber, royalties, authorWalletAddress, marketAddress, { gasLimit: '0xf00000'});
      console.log("deploy: " + contract.address);
      //await contract.deployTransaction.wait();
      setWaitForTx(processing);
      console.log("setWaitForTx");
      await provider.waitForTransaction(contract.deployTransaction.hash);
      console.log("provider.waitForTransaction :" + contract.address);
      setWaitForTx({ hash: '', message: '', status: '' });
      //suggestTokenAddition(contract.address);
      setReload(true);
      return contract.address;
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'ATO Contract deployment', e);
    }
  };

  /**
   * Add metadatas URL to ATO contract
   * @param {String} NFTMakerAddress
   * @param {String} metadatas
   */
  /*
  const setMetadatas = async (contractAddress, metadatas) => {
    setWaitForTx({ hash: '', message: 'Metamask action is required.', status: 'in progress' });
    try {
      const ato = new Contract(contractAddress, atoSC.abi, signer);
      const result = await ato.setMetadata(metadatas);
      setWaitForTx(processing);
      await provider.waitForTransaction(result.hash);
      return result;
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'Set Metadatas in ATO Contract', e);
    }
  };
  */

  /**
   * Sell Ato contract to the market
   * @param {String} nftAddress
   * @param {Number} price
   * @param {Number} amount
   */
  /*
  const sell = async (nftAddress, price, amount) => {
    const convertedPrice = parseInt(price * 10 ** 2);
    setWaitForTx({ hash: '', message: 'Please sign your MetaMask transaction.', status: 'In progress' });
    try {
      const marketSell = await market.sell(nftAddress, convertedPrice, amount);
      setWaitForTx(processing);
      provider.once(marketSell.hash, (transaction) => {
        if (transaction.confirmations) {
          setWaitForTx({
            hash: transaction.hash,
            message: 'Congrats! Your artwork is on ATO',
            status: 'validated',
          });
          setTimeout(() => setWaitForTx({ hash: '', message: '', status: '' }), 4000);
          setReload(!reload);
        }
      });
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'Sell in Market Contract', e);
    }
  };
  */

  // TO DO: remove the approve

  /**
   * Approve dai transaction
   * @param {String} nftAddress
   * @param {Number} amount
   * @param {Number} price
   */
  /*
  const approveAndBuy = async (nftAddress, amount) => {
    try {
      setWaitForTx({ hash: '', message: 'Please sign your MetaMask transaction.', status: 'in progress' });
      buyNft(amount, nftAddress);
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'Dai transaction approvement', e);
    }
  };
  */

  /**
   * Buy Nft
   * @param {Number} amount
   * @param {String} nftAddress
   */
  /*
  const buyNft = async (amount, nftAddress) => {
    try {
      const marketBuy = await market.buy(amount, nftAddress);
      setWaitForTx(processing);
      provider.once(marketBuy.hash, async (transaction) => {
        if (transaction.confirmations) {
          setWaitForTx({
            hash: marketBuy.hash,
            message: `Congrats! The transaction has been confirmed.`,
            status: 'validated',
          });
          suggestTokenAddition(nftAddress);
          setTimeout(() => setWaitForTx({ hash: '', message: '', status: '' }), 4000);
          const leftSupply = await market.getLeftSupply(nftAddress);
          nfts.find((nft) => nft.address === nftAddress).left = leftSupply.toNumber();
          setNfts([...nfts]);
        }
      });
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'Buy in Market Contract', e);
    }
  };
  */

  /**
   * Mint Nft
   * @param {String} nftAddress
   * @param {Number} amount
   */
   const mintNft = async (nftAddress, amount) => {
    try {
      const ato = new Contract(nftAddress, atoSC.abi, signer);
      const result = await ato.mintBatch(amount);
      setWaitForTx(processing);
      provider.once(result.hash, async (transaction) => {
        if (transaction.confirmations) {
          setWaitForTx({
            hash: result.hash,
            message: `Congrats! The transaction has been confirmed.`,
            status: 'validated',
          });
          setTimeout(() => setWaitForTx({ hash: '', message: '', status: '' }), 4000);
          const maxSupply = await ato.max();
          let leftSupply = await ato.getTokenIdCounter();
          leftSupply = maxSupply - leftSupply;
          nfts.find((nft) => nft.address === nftAddress).left = leftSupply; //.toNumber();
          setNfts([...nfts]);
          //suggestTokenAddition(nftAddress);
          const atoMetadatasUrl = await ato.metadata();
          const metadatas = await axios.get(atoMetadatasUrl);
          suggestTokenAddition(nftAddress, nfts.symbol, 0, metadatas.data.thumbnailUrl);
          //setTimeout(() => setWaitForTx({ hash: '', message: '', status: '' }), 4000);
        }
      });
    } catch (e) {
      displayTxError(e);
      throw Exception('Contract', 'Buy in Market Contract', e);
    }
  };

/*
  const getOwnedAssets = async (nftAddress) => {
    try {
      const wasAdded = await window.ethereum.request({
        //"id":1,
        //"jsonrpc": "2.0",
        method: 'wallet_getOwnedAssets',
        params: [
          nftAddress,
          {
            "types": ["ERC20"],
            "justification": "List the know asset."
          },
        ],
      });
      console.log('wasAdded: '+wasAdded);
    } catch (error) {
      console.log('wasAdded',error);
    }
  };
*/

  //const suggestTokenAddition = async (nftAddress) => {
  const suggestTokenAddition = async (tokenAddress, tokenSymbol, tokenDecimals, tokenImage) => {
    /*
    const ato = new Contract(nftAddress, atoSC.abi, signer);
    const atoMetadatasUrl = await ato.metadata();
    const metadatas = await axios.get(atoMetadatasUrl);

    //const pinataArt = await getArtwork(nftAddress);
    const symbol = await ato.symbol();
    const tokenAddress = nftAddress;
    const tokenSymbol = symbol;
    const tokenDecimals = 0;
    const tokenImage = metadatas.data.thumbnailUrl; //pinataArt.metadata.keyvalues.thumbnailUrl;
    */

    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: tokenAddress, // The address that the token is at.
            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals, // The number of decimals in the token
            image: tokenImage, // A string url of the token logo
          },
        },
      });

      if (wasAdded) {
        console.log('Thanks! ('+wasAdded+')');
      } else {
        console.log('Your loss!('+wasAdded+')');
      }
    } catch (error) {
      console.log('wasAdded',error);
    }
  };

  const displayTxError = (e) => {
    setWaitForTx({ hash: '', message: e?.data?.message, status: 'canceled' });
    setTimeout(() => setWaitForTx({ hash: '', message: '', status: '' }), 7000);
  };


  return (
    <NftContext.Provider
      value={{
        nfts,
        // daiConvertion,
        deployContract,
        //approveAndBuy,
        mintNft,
        //sell,
        //setMetadatas,
        suggestTokenAddition,
        generateUrl,
        reload,
        pdf,
        setPdf,
        resultToast,
        setResultToast,
        loading,
        waitForTx,
        isWhitelisted
        //setResearch,
        //research,
      }}
    >
      {children}
    </NftContext.Provider>
  );
};

export default NftProvider;
